export enum SqsQueue {
  AgreementWebhooks = 'AgreementWebhooks',
  WorkdaySupplierDomestic = 'WorkdaySupplierDomestic',
  WorkdaySupplierForeign = 'WorkdaySupplierForeign',
  PlusAllianceStudentGroup = 'PlusAllianceStudentGroup',
  BfitArchive = 'BfitArchive',
  DataWarehouse = 'DataWarehouse'
}